import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import Select from './Select';
/**
 * Use this component if you need select component
 * to match the style with button component. Most likely
 * to be used for filtering in listing page.
 * Please note that this component rely on value prop
 * to apply custom styling
 */

var SelectButton = styled(Select)(_templateObject || (_templateObject = _taggedTemplateLiteral(["&& {\n  color: ", ";\n  font-weight: bold;\n  min-width: 100px;\n  ", "\n}"])), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return "\n    &:not(.ant-select-customize-input) .ant-select-selector {\n      border-color: ".concat(props.value ? props.theme.colors.primary : props.theme.colors.darkGrey, ";\n    }\n\n    .ant-select-arrow {\n      color: ").concat(props.value ? props.theme.colors.primary : props.theme.colors.darkGrey, ";\n    }\n  ");
});
export default SelectButton;